<template>
  <div @click="showPicker" class="rich-select datetime-wrapper">
    <span class="content" v-if="content">{{content}}</span>
    <span class="rich-select-placeholder" v-else>{{placeholder}}</span>
    <i class="rich-select-icon"></i>
  </div>
</template>

<script>
/**
 * 时间选择组件 基于DatePicker
 * 支持年月日时分秒 多级组合选择
 * props: {
 *  startDate: new Date(), (Date可选范围的最小值)
 *  endDate: new Date(), (Date可选范围的最大值)
 *  startColumn: month, (起始列)
 *  columnCount: 3, (列数)
 *  format: { year: 'YYYY' }, (日期格式)
 *  parseTime: fn, (控制日期的展示形式，输入为 2020-11-09-00-55 形式)
 * }
 * value输出形式 2020-11-09-00-55
 * 如果展示列 超过三个 会以 年月日/时分秒 为维度拆分成两个窗口
 */
import { isArray } from 'lodash-es'
const EVENT_INPUT = 'input'
const EVENT_CANCEL = 'cancel'
export default {
  name: 'datePickerInput',
  props: {
    title: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: String
    },
    startDate: {
      type: Date,
      default () {
        return new Date(new Date().getFullYear() - 10, 0, 1)
      }
    },
    endDate: {
      type: Date,
      default () {
        return new Date(new Date().getFullYear() + 10, 11, 31)
      }
    },
    startColumn: {
      type: String,
      default: 'year'
    },
    columnCount: {
      type: Number,
      default: 3
    },
    format: {
      type: Object,
      default () {
        return { year: 'YYYY', month: 'MM', date: 'DD', hour: 'hh', minute: 'mm', second: 'ss' }
      }
    },
    parseTime: {
      type: Function,
      default () {
        return (str) => str
      }
    },
    zIndex: {
      type: Number,
      default: 100
    },
    value: {
      type: String
    }
  },
  data () {
    return {
      startColumnList: ['year', 'month', 'date', 'hour', 'minute', 'second'],
      middle: 3,
      firstConfig: null,
      nextConfig: null,
      firstDatePicker: null
    }
  },
  computed: {
    content () {
      return this.value ? this.parseTime(this.value) : ''
    }
  },
  created () {
    this.init()
  },
  methods: {
    init () {
      if (this.columnCount <= 3) {
        this.firstConfig = {
          startColumn: this.startColumn,
          columnCount: this.columnCount
        }
        this.nextConfig = null
      } else {
        let middle = this.middle
        let startIndex = this.startColumnList.indexOf(this.startColumn)

        this.firstConfig = {
          startIndex: startIndex,
          startColumn: this.startColumn,
          columnCount: middle - startIndex
        }
        this.nextConfig = {
          startIndex: middle,
          startColumn: this.startColumnList[middle],
          columnCount: this.columnCount - middle + startIndex
        }
      }
    },
    showPicker () {
      let value = this.value ? this.value.split('-').map(val => Number(val)) : new Date()
      this.nextConfig.value = isArray(value) ? value.slice(this.firstConfig.columnCount) : value
      this.firstDatePicker = this.$createDatePicker({
        title: this.title,
        min: this.startDate,
        max: this.endDate,
        value: isArray(value) ? value.slice(0, this.firstConfig.columnCount) : value,

        columnCount: this.firstConfig.columnCount,
        startColumn: this.firstConfig.startColumn,
        confirmTxt: this.gettext('下一步'),
        zIndex: this.zIndex,
        format: this.format,
        onSelect: this.startSelectHandle,
        onCancel: this.cancelHandle
      })
      this.firstDatePicker.show()
    },
    startSelectHandle () {
      let selectedText = arguments[2] || []
      if (!this.nextConfig) {
        this.selectHandle(selectedText)
      } else {
        this.nextShowPicker(selectedText)
      }
    },
    nextShowPicker (startSelectedText) {
      let _this = this
      this.$createDatePicker({
        title: this.title,
        min: this.startDate,
        max: this.endDate,
        value: this.nextConfig.value,

        columnCount: this.nextConfig.columnCount,
        startColumn: this.nextConfig.startColumn,
        cancelTxt: this.gettext('上一步'),
        zIndex: this.zIndex,
        format: this.format,
        onSelect () {
          let selectedText = arguments[2] || []
          _this.selectHandle(startSelectedText.concat(selectedText))
        },
        onCancel () {
          _this.firstDatePicker.show()
        }
      }).show()
    },
    selectHandle (selectedText) {
      let time = selectedText.reduce((val1, val2) => {
        return val1 ? `${val1}-${val2}` : val2
      }, '')
      this.$emit(EVENT_INPUT, time)
    },
    cancelHandle () {
      this.$emit(EVENT_CANCEL)
    }
  }
}

</script>

<style  lang="scss" scoped>
.datetime-wrapper {
  overflow: auto;

  &-btn {
    text-align: left;
    color: $color-light-grey;
    font-size: $fontsize-medium;
  }

  // 组件使用rich-select需设置disabled属性点击时禁止picker弹出，但不需要disabled的样式
  ::v-deep .rich-select_disabled {
    background-color: #fff
  }

  .panel-wrap {
    width: 100%;
    position: absolute;
    top: 60Px;
    bottom: 0;
    overflow: auto;
    .checkbox {
      padding: 0 20px;
    }
  }

  .content{
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 90%;
  }
}
</style>
